<h1>Rad Guitar Practice Tool</h1>

<p>
  Welcome to Raguprato. This rad guitar practice tool will help you improve your guitar
  skills.
</p>

<section>
  <h2>How to use</h2>

  <p>
    This tool was designed to be as simple as possible. Just head over to the <a
      class="fancy-link"
      href="#/new-lesson">new lessons page</a> to create a lesson for yourself and start practicing.
  </p>
  <p>You can add videos, chords and strumming patterns to every lesson you create.</p>
  <p>
    You don't need an account or a credit card. We value your privacy and safe your
    lessons only locally in your browser.
  </p>

  <div id="chart" />
</section>

<style type="text/scss">
  p {
    margin: 1rem 0;
  }
</style>
